module.exports = __webpack_public_path__ + "static/media/chepsPpl.42a57b27.jpg";